import {getTestProps} from '@benchling/js-test-utils';
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import ArchiveRecordLabel from 'archive/components/ArchiveRecordLabel';
import {StudyPhase} from 'graphql-client/__generated/graphqlGlobalTypes';
import GenerateStudyReportButton from 'studies/workspace/overview/GenerateStudyReportButton';
import SetStudyPhaseDropdown from 'studies/workspace/overview/SetStudyPhaseDropdown';
import StudyPhaseOverview from 'studies/workspace/overview/StudyPhaseOverview';
import StudyReviewOverview from 'studies/workspace/overview/StudyReviewOverview';
import StudyDescriptionEditor from 'studies/workspace/StudyDescriptionEditor';
import {Header1} from 'ui-library/Headers';

import {StudyOverviewTabContentsProps} from '../utils/TypedStudyTypes';
import Section from './Section';

export default function SharedStudyOverviewTabContents(props: StudyOverviewTabContentsProps): JSX.Element {
  return (
    <div
      className={classNames('react-tab-container', css(styles.tabContainerKeepScrollbar))}
      {...getTestProps({component: 'SharedStudyOverviewTabContents', element: 'root'})}
    >
      <div className="react-tab-container-narrowTab">
        <div className={css(styles.headerSection)}>
          <div className={css(styles.headerTitle)}>
            <Header1>{props.study.name}</Header1>
            <ArchiveRecordLabel
              item={{name: props.study.name, id: props.study.id, archiveRecord: props.study.archiveRecord}}
            />
          </div>
          <div className={css(styles.headerButtons)}>
            <GenerateStudyReportButton study={props.study} />
            <SetStudyPhaseDropdown
              study={{
                id: props.study.id,
                phase: props.study.phase,
                studyType: props.study.studySchema.studyType,
              }}
              refetch={props.refetch}
              isDisabled={!props.isEditable}
              requiresApproval={props.isDesignApprovalRequiredToProceed}
              allowReturnToDesignPhase={props.allowReturnToDesignPhase}
            />
          </div>
        </div>
        <div>
          <StudyDescriptionEditor study={props.study} refetch={props.refetch} isWritable={props.isEditable} />
        </div>
        <StudyPhaseOverview study={props.study} />
        {props.design && <Section title="Design">{props.design}</Section>}
        <Section title="Execution" icon={props.study.phase === StudyPhase.DESIGN ? 'lock' : null}>
          {props.execution}
        </Section>
        {props.isAnalysisEnabled && (
          <Section title="Review">
            <StudyReviewOverview study={props.study} />
          </Section>
        )}
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  tabContainerKeepScrollbar: {
    overflowY: 'scroll',
  },
  headerSection: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 8,
    marginBottom: 15,
  },
  headerTitle: {
    flex: 1,
  },
  headerButtons: {
    flex: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
});
